import { Actions } from '../actions/userOrganizations';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IUserOrganization } from '../interfaces/userOrganization';

export type State = DeepReadonly<{
  isFetching: boolean;
  hasFetched: boolean;
  userOrganizations: IUserOrganization[] | null;
  allUserOrganizations: IUserOrganization[];
  error: AxiosError | Error | null;
}>;

const initialState: State = {
  isFetching: false,
  hasFetched: false,
  userOrganizations: null,
  allUserOrganizations: [],
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_USER_ORGANIZATIONS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_USER_ORGANIZATIONS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        hasFetched: true,
        userOrganizations: action.payload.sort((a, b) => a.name.localeCompare(b.name)),
        error: null
      };
    case 'FETCH_USER_ORGANIZATIONS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case 'SET_ALL_USER_ORGANIZATIONS':
      return {
        ...state,
        allUserOrganizations: action.payload
      };
    default:
      return state;
  }
}
